<template>
  <div id="app" class="app">
    <LoadingComponent v-show="pageLoading"></LoadingComponent>
    <router-view
      v-if="baseData && activityData"
      :baseData="baseData"
      :activityData="activityData"
    />
    <base-component :baseData="baseData" v-if="baseData"></base-component>
    <toast-component></toast-component>
    <div class="lottery-toast" v-if="activityData && activityData.lotteryToastImg && activityData.lotteryToastUrl && isShowLotteryToast">
      <img :src="activityData.lotteryToastImg" class="toast-img" alt="" @click="handleLottery">
      <img src="https://yunyingcdn.thecover.cn/o_1hj6mg6vjaqnhjsvq0e3fr2e9.png" class="colse" alt="" @click="setShowLotteryToast(null)">
    </div>
  </div>
</template>

<script>
import COVER from '@/utils/COVER'
import BaseComponent from '@/components/Base'
import LoadingComponent from '@/components/Loading'
import ToastComponent from "@/components/Toast"

import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  data() {
    return {
      aid: '',
      activityData: null,
      baseData: null,
    }
  },
  watch: {
    $route(to) {
      this.setPageLoadingAsync(true);
      this.aid = to.query.id || ''
      this.aid && this.getActivityData();
    },
    toastData(val) {
      if (val) {
        setTimeout(() => {
          this.setToastData(null)
        }, 3000)
      }
    },
  },
  computed: {
    ...mapState(['pageLoading', 'toastData', 'isShowLotteryToast']),
  },
  created() {
    this.aid = this.$router.history.current.query.id || ''
    this.setAid(this.aid);
    this.aid && this.getActivityData();
  },
  components: {
    BaseComponent,
    LoadingComponent,
    ToastComponent
  },
  methods: {
    ...mapActions([
        'setAid',
      'setPageLoadingAsync',
      'setShowLotteryToast',
    ]),
    ...mapMutations(['setToastData', 'setActivityData']),
    getActivityData() {
      this.$track(this.aid, 'load')
      
      COVER.$get('/activity/config', {
        aid: this.aid
      }).then((res) => {
        if (res.errno == 0) {
          let data = res.data
          document.title = data.title
          const activityData = Object.assign(data.templateConfig, { aid: this.aid, title: data.title, isAppShow: data.isAppShow }, data.openApp || {})
          this.setActivityData(activityData)
          this.activityData = activityData
          this.baseData = Object.assign({
            isAppShow: data.isAppShow,
            music: data.music,
            share: data.share,
            isEnd: data.serverTime >= new Date(data.endTime).getTime(),
          }, data.openApp || {});
        } else {

        }
      })
    },
    handleLottery() {
      this.$track(this.aid, 'adtoast', {
        value: '点击抽奖弹窗'
      });
      
      window.location.href = this.activityData.lotteryToastUrl;
    },
  }
}
</script>

<style lang="less">
.lottery-toast {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 100vh;
  background: rgba(#000, .8);
  display: flex;
  justify-content: center;
  flex-direction: column;
  z-index: 100;
  .toast-img {
    width: 100%;
    transform: scale(.5);
    animation: antoastad .4s 0s ease forwards;
  }
  .colse {
    width: 7vw;
    height: 7vw;
    position: fixed;
    bottom: 5vw;
    left: 46.5vw;
  }
}
@keyframes antoastad {
  0% {
    transform: scale(.5);
  }
  100% {
    transform: scale(1);
  }
}
</style>